import * as React from "react";
import * as ReactDOM from "react-dom";
import CourseSearch from "./CourseSearch";
import { BrowserRouter as Router, Route } from "react-router-dom";

ReactDOM.render(
  <Router>
	<React.Fragment>
		<Route path="/search/courses/:tag?" component={CourseSearch} />
	</React.Fragment>
  </Router>,
  document.getElementById("search")
);
